import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import originalMoment from 'moment';
import { extendMoment } from 'moment-range';
import DatePicker from '@components/@core/DatePicker';
import Dropdown from '@components/@core/Dropdown';

const TrendChart = loadable(() => import('./TrendChart'), { ssr: false });
const ReviewChart = loadable(() => import('./ReviewChart'), { ssr: false });
const moment = extendMoment(originalMoment);

const Visibility = ({ company, date, onDateChange }) => {
    const products = company?.products || [];
    const [selectedProduct, setSelectedProduct] = useState(company);

    useEffect(() => {
        setSelectedProduct(company);
    }, [products]);

    return (
        <div className="card mt-3">
            <p className="dsl-b24 bold">Rating Trends</p>
            <div className="d-h-between border-bottom py-3">
                <Dropdown className="visibility-product" placeholder="All Products" data={products} getValue={(e) => e.name} returnBy="data" onChange={(e) => setSelectedProduct(e[0])} />
                <DatePicker calendar="range" append="caret" format="MMM D, YY" as="span" align="right" value={date} closeAfterSelect onSelect={onDateChange} />
            </div>
            <div className="mt-4">
                <p className="dsl-b18 bold">Rating Trend</p>
                <div className="d-flex ssm-column">
                    <div className="d-flex-1">
                        <div className="visibility-item mt-3">
                            <div className="label d-h-start">
                                <div className="mark" style={{ backgroundColor: 'red' }} />
                                <p className="dsl-b12 my-2">Star rating ave</p>
                            </div>
                            <p className="dsl-b16 my-2">{Math.round((selectedProduct.stats?.rating_avg || 0) * 10) / 10}</p>
                        </div>
                        <div className="visibility-item">
                            <div className="label d-h-start">
                                <div className="mark" style={{ backgroundColor: 'green' }} />
                                <p className="dsl-b12 my-2">%recommended ave</p>
                            </div>
                            <p className="dsl-b16 my-2">{Math.round((selectedProduct.stats?.rating_recommended_avg || 0) * 100) / 100}</p>
                        </div>
                    </div>
                    <div className="d-flex-2">
                        <TrendChart company={company} date={date} selected={selectedProduct} />
                    </div>
                </div>
            </div>
            <div className="mt-4">
                <p className="dsl-b18 bold">Reviews</p>
                <div className="d-flex ssm-column">
                    <div className="d-flex-1">
                        <div className="visibility-item mt-3">
                            <div className="label d-h-start">
                                <div className="mark" style={{ backgroundColor: '#376caf' }} />
                                <p className="dsl-b12 my-2">Verified</p>
                            </div>
                            <p className="dsl-b16 my-2">{selectedProduct.stats?.rating_count || 0}</p>
                        </div>
                        <div className="visibility-item">
                            <div className="label d-h-start">
                                <div className="mark" style={{ backgroundColor: 'darkorange' }} />
                                <p className="dsl-b12 my-2">Dealerships</p>
                            </div>
                            <p className="dsl-b16 my-2">{selectedProduct.stats?.rating_dealership_count || 0}</p>
                        </div>
                        <div className="visibility-item">
                            <div className="label d-h-start">
                                <div className="mark" style={{ backgroundColor: '#343f4b' }} />
                                <p className="dsl-b12 my-2">Blocked</p>
                            </div>
                            <p className="dsl-b16 my-2">{selectedProduct.stats?.blocked_count || 0}</p>
                        </div>
                    </div>
                    <div className="d-flex-2">
                        <ReviewChart company={company} date={date} selected={selectedProduct} />
                    </div>
                </div>
            </div>
        </div>
    );
};

Visibility.propTypes = {
    company: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        products: PropTypes.array,
        stats: PropTypes.shape({
            product_count: PropTypes.number,
            popularity_score: PropTypes.number,
            rating_recommended_avg: PropTypes.number,
            rating_count: PropTypes.number,
            rating_dealership_count: PropTypes.number,
        }),
    }),
    date: PropTypes.any,
    onDateChange: PropTypes.func,
};

Visibility.defaultProps = {
    company: {
        id: 0,
        name: '',
        products: [],
        stats: {
            product_count: 0,
            popularity_score: 0,
            rating_recommended_avg: 0,
            rating_count: 0,
            rating_dealership_count: 0,
        },
    },
    date: moment.range(moment().startOf('month').format('YYYY-MM-DD'), moment().endOf('month').format('YYYY-MM-DD')),
    onDateChange: () => {},
};

export default Visibility;
